export function isStringEmpty(value) {
    return value === undefined || value === null || value === `` || value === `null`;
}
